// Static option constants for the Model Route create/edit form.
// Provider options are NOT here — they come from GET /models/vendors (the enum grows).

export const AUTH_OPTIONS = ['Access Token']

// Display-only i18n keys (modelRoute ns); AUTH_OPTIONS values stay as form values.
export const AUTH_OPTION_LABEL_KEYS: Record<string, string> = {
  'Access Token': 'create.authAccessToken',
}

export const CAPABILITY_OPTIONS = ['Reasoning', 'Vision', 'Tool Use', 'Long Context']

// TODO(model-route-api): in the design but caps.features has no bit values for these
// yet — shown disabled until backend extends the enum
export const CAPABILITY_OPTIONS_COMING_SOON = ['Image Generation', 'RAG', 'Subagent']
